import { Directory } from "../../../../../domain/drawing";

export interface IEditTreeSource<T> {
  saveEditTree(treeSource: Directory<string, T>[]): Promise<void>;
}

export function instanceOfIEditTreeSource<T>(instance: any): instance is IEditTreeSource<T> {
  return (instance
    && instance.saveEditTree !== undefined);
}
